import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { Trans } from '@lingui/react';
import React from 'react';
import styled from 'styled-components';
import { Box, useBreakpoint, Flex, Popover, InfoFilled, Group, Text, Button } from '@landr/maestro';

var _templateObject;
var StyledInfoIcon = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    cursor: pointer;\n"])));
var ProfileHiddenTooltip = function ProfileHiddenTooltip(_ref) {
  var isProfilePrivate = _ref.isProfilePrivate,
    onCtaClick = _ref.onCtaClick;
  var isTablet = useBreakpoint('lg');
  var isMobile = useBreakpoint('md');
  if (!isProfilePrivate) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Flex, {
    onClick: function onClick(event) {
      if (isTablet) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, /*#__PURE__*/React.createElement(Popover, {
    usePortal: false,
    placement: "bottom-end",
    triggerEvent: isTablet ? 'click' : 'hover'
  }, function (_ref2) {
    var close = _ref2.close;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popover.Trigger, null, /*#__PURE__*/React.createElement(StyledInfoIcon, null, /*#__PURE__*/React.createElement(InfoFilled, {
      size: "sm"
    }))), /*#__PURE__*/React.createElement(Popover.Content, {
      pb: "lg"
    }, /*#__PURE__*/React.createElement(Group, {
      direction: "vertical",
      gutter: "xs",
      alignItems: "center",
      onClick: close
    }, /*#__PURE__*/React.createElement(Group.Item, {
      paddingX: "xxs",
      pt: "sm",
      pb: "xs"
    }, /*#__PURE__*/React.createElement(Flex, {
      flexDirection: "column",
      width: isMobile ? '100%' : '320px'
    }, /*#__PURE__*/React.createElement(Text, {
      fontWeight: "bold"
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "d7mIek"
    })), /*#__PURE__*/React.createElement(Text, {
      contrast: "low"
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "xKldJb"
    })))), /*#__PURE__*/React.createElement(Group.Item, {
      width: "100%"
    }, /*#__PURE__*/React.createElement(Button, {
      isFull: true,
      isRounded: true,
      size: "sm",
      onClick: onCtaClick
    }, /*#__PURE__*/React.createElement(Trans, {
      id: "Fuzo5L"
    }))))));
  }));
};

export { ProfileHiddenTooltip };
